import { Card, Spin } from "antd";
import { useParams } from "react-router-dom";
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";
import { Fragment, useEffect, useState } from "react";
import { getDoc } from "../../components/action";
import { BackBtn } from "../../components/commonComponents";


export default function DocViewerPage() {
    const { uuid } = useParams();
    
    const [doc, setDoc] = useState(null);
    const [docType, setDocType] = useState(null);
    const [loading, setLoading] = useState(false)
    
    useEffect(() => {
        setLoading(true)
        getDoc(uuid).then(res => {
            setDoc(res[0])
            setDocType(res[0]?.file_url?.split('.')?.pop()?.trim())
            setLoading(false)
        }).catch(err => {
            console.log(err)
            setLoading(false)
        })
    }, [uuid])
    
    
    // Construct the proxy URL for MinIO access
    const getDocUrl = () => {
        if (!doc?.file_url) return null;
        // Remove the leading slash if present and construct the proxy URL
        const filePath = doc.file_url.startsWith('/') ? doc.file_url.substring(1) : doc.file_url;
        return `https://e-library.gcaa.ge/docview/${filePath}`;
    };
    
    return (
        <Card
            title={'დოკუმენტი: ' + doc?.name|| ''}
            style={{ height: '100%', display: 'flex', flexDirection: 'column' }}
            bodyStyle={{ height: '100%', display: 'flex', flexDirection: 'column' }}
        >
            <BackBtn path='/' label='დაბრუნება' />
            <Fragment >

                {
                    loading || !doc ? <Spin tip={'Loading...'} style={{display: 'flex', flexDirection: 'column', height: '100%', justifyContent: 'center', alignItems: 'center'}} size="large" /> :
                        <DocViewer
                            style={{ display: 'flex', flexDirection: 'column', height: '100%' }}
                            containerStyle={{ height: '100%' }}
                            documents={[{ uri: getDocUrl(), fileType: docType }]}
                            pluginRenderers={DocViewerRenderers}
                            initialActiveDocument={0}
                            
                            config={{
                                header: {
                                    disableHeader: true,
                                    disableFileName: true,
                                    retainURLParams: true,
                                    showFileName: false,
                                },
                                csvDelimiter: ",",
                                docType: docType,
                                pdfZoom: {
                                    defaultZoom: 1,
                                    zoomJump: 0.2,
                                    zoomStep: 0.1
                                },
                            }}
                            onDocumentLoadSuccess={() => {
                                console.log('document loaded')
                            }}
                            errorComponent={() => {
                                return <div>Error</div>
                            }}
                        />
                }
            </Fragment>
        </Card>
    )
}